__turbopack_context__.v({
  "compact": "FolderMediaContainer-module__8EY_Hq__compact",
  "container": "FolderMediaContainer-module__8EY_Hq__container",
});
